var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-hero g-px g-mb" }, [
    _c("div", { staticClass: "row-c-nm event-form" }, [
      _c("h2", [_vm._v(_vm._s(_vm.heading))]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form form--error-handling",
          attrs: { enctype: "multipart/form-data" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c("div", { staticClass: "swiper-container" }, [
            _c("div", { staticClass: "swiper-wrapper" }, [
              _vm.newEntry
                ? _c("div", { staticClass: "swiper-slide" }, [
                    _c(
                      "h3",
                      [_vm._t("step1-title", [_vm._v("Intentieverklaring")])],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rte mb-6" },
                      [
                        _vm._t("step1-text", [
                          _vm._v("Reveil in jouw gemeente")
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "swiper-slider__btn-row" }, [
                      _c("span", [
                        _vm._v(
                          "Stap " +
                            _vm._s(_vm.slide) +
                            "/" +
                            _vm._s(_vm.totalSlides)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--green",
                          attrs: { type: "button" },
                          on: { click: _vm.nextSlide }
                        },
                        [_vm._v("Volgende")]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c(
                  "h3",
                  [
                    _vm._t("step2-title", [
                      _vm._v("Gegevens centrale contactpersoon")
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [
                    _vm._t("step2-text", [
                      _vm._v(
                        "Voor Reveil is het handig om de coördinaten te ontvangen van de spilfiguur/centrale contactpersoon van het  Reveilmoment. Als jij dat bent, mag je gewoon jouw gegevens noteren."
                      )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.firstNameContact.error }
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.firstNameContact.val,
                            expression: "fields.firstNameContact.val"
                          }
                        ],
                        attrs: {
                          id: "input-first-name-contact",
                          name: "firstNameContact",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.firstNameContact.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(
                              _vm.fields.firstNameContact
                            )
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.firstNameContact,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.firstNameContact.error
                        ? _c("span", [
                            _vm._v("Gelieve een voornaam in te geven.")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.lastNameContact.error }
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.lastNameContact.val,
                            expression: "fields.lastNameContact.val"
                          }
                        ],
                        attrs: {
                          id: "input-last-name-contact",
                          name: "lastNameContact",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.lastNameContact.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.lastNameContact)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.lastNameContact,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.lastNameContact.error
                        ? _c("span", [
                            _vm._v("Gelieve een familienaam in te geven.")
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.organisation.error }
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.organisation.val,
                            expression: "fields.organisation.val"
                          }
                        ],
                        attrs: {
                          id: "input-organisation",
                          name: "organisation",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.organisation.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.organisation)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.organisation,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.organisation.error
                        ? _c("span", [
                            _vm._v("Gelieve een organisatie in te geven.")
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.emailContact.error }
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.emailContact.val,
                            expression: "fields.emailContact.val"
                          }
                        ],
                        attrs: {
                          id: "input-email-contact",
                          name: "emailContact",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.emailContact.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorMail(_vm.fields.emailContact)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.emailContact,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.emailContact.error
                        ? _c("span", [
                            _vm._v(
                              "Gelieve een correct e-mailadres in te geven."
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "input-phone-contact" } }, [
                      _vm._v("Telefoonnummer")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.phoneContact.val,
                          expression: "fields.phoneContact.val"
                        }
                      ],
                      attrs: {
                        id: "input-phone-contact",
                        name: "phoneContact",
                        type: "text"
                      },
                      domProps: { value: _vm.fields.phoneContact.val },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.fields.phoneContact,
                            "val",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.locationCity.error }
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("small", [
                        _vm._v(
                          "Typ een postcode of stad en selecteer een stad uit de lijst."
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-select",
                        {
                          attrs: {
                            label: "label",
                            clearable: false,
                            value: _vm.fields.locationCity.val,
                            options: _vm.cityOptions,
                            id: "input-location-city"
                          },
                          on: {
                            search: _vm.onSearch,
                            input: _vm.setLocationCity
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { slot: "no-options" },
                              slot: "no-options"
                            },
                            [_vm._v("Selecteer een gemeente of stad")]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.fields.locationCity.error
                        ? _c("span", [
                            _vm._v(
                              "Gelieve een gemeente of stad te selecteren."
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-slider__btn-row" }, [
                  _c("span", [
                    _vm._v(
                      "Stap " +
                        _vm._s(_vm.slide) +
                        "/" +
                        _vm._s(_vm.totalSlides)
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.newEntry
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--rose",
                            attrs: { type: "button" },
                            on: { click: _vm.prevSlide }
                          },
                          [_vm._v("Terug")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--green",
                        attrs: { type: "button" },
                        on: { click: _vm.nextSlide }
                      },
                      [_vm._v("Volgende")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c("h3", [_vm._t("step3-title", [_vm._v("Troostactie")])], 2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [_vm._t("step3-text")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Omschrijf jouw troostactie")]),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        "ENTER = nieuwe paragraaf, SHIFT+ENTER = nieuwe regel"
                      )
                    ]),
                    _vm._v(" "),
                    _c("ckeditor", {
                      attrs: { editor: _vm.editor, config: _vm.editorConfig },
                      model: {
                        value: _vm.fields.contentBlock.val,
                        callback: function($$v) {
                          _vm.$set(_vm.fields.contentBlock, "val", $$v)
                        },
                        expression: "fields.contentBlock.val"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v("Foto")]),
                      _vm._v(" "),
                      _c("file-upload", {
                        attrs: {
                          "folder-id": _vm.asset.folderId,
                          "field-id": _vm.asset.fieldId,
                          "element-id": _vm.asset.elementId,
                          "original-name": _vm.asset.originalName,
                          url: _vm.asset.url
                        },
                        on: { uploadComplete: _vm.onUploadComplete }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Links")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v("Links naar jouw website of Facebook-event, ...")
                    ]),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _c("table", { staticClass: "w-full" }, [
                      _c(
                        "tbody",
                        _vm._l(_vm.fields.externalLinks.val, function(
                          row,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: row.link,
                                    expression: "row.link"
                                  }
                                ],
                                attrs: { type: "text", placeholder: "http://" },
                                domProps: { value: row.link },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(row, "link", $event.target.value)
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right w-10" }, [
                              index > 0
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn--rose",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteRow(
                                            _vm.fields.externalLinks.val,
                                            row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Wis")]
                                  )
                                : _vm._e()
                            ])
                          ])
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--rose mt-1",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.addRow(_vm.fields.externalLinks.val, {
                              link: ""
                            })
                          }
                        }
                      },
                      [_vm._v("+ Voeg een link toe")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-slider__btn-row" }, [
                  _c("span", [
                    _vm._v(
                      "Stap " +
                        _vm._s(_vm.slide) +
                        "/" +
                        _vm._s(_vm.totalSlides)
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--rose",
                        attrs: { type: "button" },
                        on: { click: _vm.prevSlide }
                      },
                      [_vm._v("Terug")]
                    ),
                    _vm._v(" "),
                    _vm.newEntry
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--green",
                            attrs: { type: "button" },
                            on: { click: _vm.nextSlide }
                          },
                          [_vm._v("Volgende")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.newEntry
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--green",
                            attrs: { type: "submit" }
                          },
                          [_vm._v("Verzenden")]
                        )
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.newEntry
                ? _c("div", { staticClass: "swiper-slide" }, [
                    _c(
                      "h3",
                      [
                        _vm._t("step4-title", [
                          _vm._v("Nog vragen of onduidelijkheden?")
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rte mb-6" },
                      [_vm._t("step4-text", [_vm._m(7)])],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "input-remarks" } }, [
                        _vm._v("Jouw vragen of opmerkingen")
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.remarks.val,
                            expression: "fields.remarks.val"
                          }
                        ],
                        attrs: {
                          id: "input-remarks",
                          name: "remarks",
                          rows: "8"
                        },
                        domProps: { value: _vm.fields.remarks.val },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.remarks,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "swiper-slider__btn-row" }, [
                      _c("span", [
                        _vm._v(
                          "Stap " +
                            _vm._s(_vm.slide) +
                            "/" +
                            _vm._s(_vm.totalSlides)
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn--rose",
                            attrs: { type: "button" },
                            on: { click: _vm.prevSlide }
                          },
                          [_vm._v("Terug")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn--green",
                            attrs: {
                              type: "submit",
                              disabled: this.disableSubmit
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !this.disableSubmit,
                                    expression: "!this.disableSubmit"
                                  }
                                ]
                              },
                              [_vm._v("Verzenden")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: this.disableSubmit,
                                    expression: "this.disableSubmit"
                                  }
                                ]
                              },
                              [_vm._v("Even geduld")]
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c(
                  "h3",
                  [
                    _vm._t("step5-title", [_vm._v("Troostactie geregistreerd")])
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [_vm._t("step5-text", [_c("p", [_vm._v("Bedankt!")])])],
                  2
                )
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-first-name-contact" } }, [
      _vm._v("Voornaam "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-last-name-contact" } }, [
      _vm._v("Familienaam "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-organisation" } }, [
      _vm._v("Organisatie "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-email-contact" } }, [
      _vm._v("E-mailadres "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-location-city" } }, [
      _vm._v("Gemeente of stad waar je een troostactie wil brengen "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-0" }, [
      _vm._v("\n                                Hoe ziet jouw actie er uit?"),
      _c("br"),
      _vm._v(
        "\n                                Pas op: jouw info verschijnt onbewerkt op de website.\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v("Vergeet "),
      _c("em", [_vm._v("http://")]),
      _vm._v(" niet!")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Aarzel niet om "),
      _c("a", { attrs: { href: "/contact" } }, [_vm._v("ons te contacteren")]),
      _vm._v(" of hieronder jouw specifieke vraag neer te schrijven."),
      _c("br"),
      _vm._v("We kijken alvast heel erg uit naar jullie aanpak.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }